export default __webpack_public_path__ + "static/media/selected11.264f2d3b.png";